import * as i18next from 'i18next';

export class BookingClass {
    static get Business(): string { return 'Business'; }
    static get Economic(): string { return 'Economic'; }
    static get EconomicPremium(): string { return 'EconomicPremium'; }
    static get EconomicTourist(): string { return 'EconomicTourist'; }
    static get First(): string { return 'First'; }

    static listForSearch(): string[] {
        return [
            BookingClass.Economic,
            //BookingClass.EconomicPremium,
            BookingClass.Business
        ];
    }

    static classLabel(className: string): string {
        return i18next.t('label_flight_class_' + className.toLowerCase());
    }
}
